export default __webpack_public_path__ + "static/media/warning--height-restriction--g5.079c301b.png";